/**
 * Special character validation for document form fields.
 * Same approach as task name in TaskForm: value cannot contain only special characters.
 * Must have at least one alphanumeric character (a-z, A-Z, 0-9).
 *
 * @param {string} value - The input value to check
 * @returns {boolean} - true if value is empty or contains at least one alphanumeric (valid), false if only special chars
 */
export const isValidDocumentField = (value) => {
  if (value == null || !String(value).trim()) return true;
  return /[a-zA-Z0-9]/.test(String(value).trim());
};
